export default "__VITE_ASSET__jns1dA6B__"